import React, { useState } from "react";
import Footer from "../../CustomComponents/Footer/Footer.jsx";
// import DestinationLinks from "../../CustomComponents/DestinationLinks/DestinationLinks.jsx";
import Highlights from "../../CustomComponents/Highlights/Highlights.jsx";
import Testimonial from "../../CustomComponents/Testimonial/Testimonial.jsx";
import ImageSlider from "../../CustomComponents/ImageSlider/ImageSlider.jsx";
import FilterPackages from "../../CustomComponents/FilterPackages/FilterPackages.jsx";
import BannerMain from "../../CustomComponents/BannerMain/BannerMain.jsx";
import CustomSearchFormHotels from "../../CustomComponents/SearchForm/CustomSearchFormHotels/CustomSearchFormHotels.jsx";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData.jsx";
import { useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import AllDestinationsSlider from "../../CustomComponents/AllDestinationsSlider/AllDestinationsSlider.jsx";
import ComplexMarkerIcons from "../../CustomComponents/ComplexMarkerIcons/ComplexMarkerIcons.jsx";
import Loader from "../../CustomComponents/Loader/Loader.jsx";
import Skeleton from "react-loading-skeleton";
import Themes from "../../CustomComponents/Themes/Themes.jsx";
import NewHolidaysSearchForm from "../../CustomComponents/SearchForm/NewHolidaysSearchForm/NewHolidaysSearchForm.jsx";
import OgMetaTitles from "../../CustomComponents/PageMetaData/OgMetaTitles.jsx";
import BreadcrumbSchema from "../../CustomComponents/Schema/BreadcrumbSchema.js";
import NewUITopSellingPackages from "../../CustomComponents/NewComponents/NewUIPackages/NewUITopSellingPackages.jsx";
import NewUIBookWithUs from "../../CustomComponents/NewComponents/NewUIBookWithUs/NewUIBookWithUs.jsx";
import DestinationGallery from "../../CustomComponents/NewComponents/NewDestinationSection/DestinationGallery.jsx";
import HotelCard from "../../CustomComponents/NewComponents/NewUiHotels/HotelCard.jsx";
import ThemesGallery from "../../CustomComponents/NewComponents/NewUiThemes/ThemesGallery.jsx";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI.jsx";
import NewUiSearchFormHolidays from "../../CustomComponents/NewComponents/NewUiSearchForm/NewUiSearchFormHolidays/NewUiSearchFormHolidays.jsx";
import NewTestimonial from "../../CustomComponents/NewComponents/NewTestimonial/NewTestimonial.jsx";
import testimonialImg from "../../assets/images/new-testimonial.png";

function Home() {
  const [loader, setLoader] = useState(false);
  const isVerifiedToken = localStorage.getItem("isVerified");
  const role = localStorage.getItem("role");

  const navigate = useNavigate();

  useEffect(() => {
    // const isVerifiedToken = localStorage.getItem('isVerified');
    const AccountStatus = localStorage.getItem("AccountStatus");
    // console.log(AccountStatus, "AccountStatus")
    // const role = localStorage.getItem('role');

    // console.log(isVerifiedToken, "token");
    // console.log(role, "role");

    if (AccountStatus === "disable") {
      console.error("Error: Invalid token or undefined for agent role");
      // showErrorToast("First Fill all required ")
      navigate("/agent-account");
    }
  }, [navigate]);

  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");

  // console.log(token, "check_token");
  // console.log(userType, "checkagentdetails");
  const [customerDataa, setCustomerData] = useState(null);
  // console.log(customerDataa, "customerDataasss");
  const [footerDestinations, setFooterDestinations] = useState([]);

  const fetchAgentDetails = (token) => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/user-profile`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        // setAgentData(data.data.agent);
        localStorage.setItem("userDetails", JSON.stringify(data.data));
        localStorage.setItem(
          "AccountStatus",
          JSON.stringify(data.data.accountStatus)
        );
        if (data.success) {
          if (!data?.data?.name || !data?.data?.email || !data?.data?.phone) {
            return navigate("/agent-account");
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching agent details:", error);
      });
  };

  const fetchCustomerDetails = (token) => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/user-profile`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setCustomerData(data.data);
          localStorage.setItem("userDetails", JSON.stringify(data.data));
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  };

  // console.log(token, userType);
  useEffect(() => {
    if (token && userType === "agent") {
      fetchAgentDetails(token);
    } else if (userType === "customer") {
      // window.location.reload()
      fetchCustomerDetails(token);
    }
  }, [token]);

  useEffect(() => {
    fetchDestinations();
  }, []);

  const fetchDestinations = async () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    // myHeaders.append(
    //   "Authorization",
    //   "Bearer " + localStorage.getItem("token")
    // );

    const formData = new FormData();
    formData.append("limit", 7);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: formData,
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setFooterDestinations(result?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div id="home">
      <PageMetaData
        title="Mountain Mysteries - Book Himachal Pradesh Holiday Tour Packages Online"
        description="Book Himachal Pradesh  holiday Tour Package at the best price with Mountain Mysteries. Enjoy scenic beauty, adventure, and cultural experiences. Book your dream vacation today!"
        keywords="Himachal Pradesh Tour Package Himachal Pradesh Holiday Tour"
        canonicalUrl={"https://www.mountainmysteries.com/"}
      />
      <OgMetaTitles
        title="Mountain Mysteries - Book Himachal Pradesh Holiday Tour Packages Online"
        type="Book Himachal Pradesh  holiday Tour Package at the best price with Mountain Mysteries. Enjoy scenic beauty, adventure, and cultural experiences. Book your dream vacation today!"
        url="https://www.mountainmysteries.com/"
      />
      <BreadcrumbSchema />
      {/* <NewHolidaysSearchForm
        topRadios={["Culture", "Family", "Honeymoon", "OffBeat"]}
      /> */}

      <NewUiSearchFormHolidays />
      {/* <BannerMain /> */}
      <section className="top_bottom_same_padding new_ui_bg">
        <NewUITopSellingPackages heading={"Top Holiday Packages"} />
      </section>
      <section className="top_bottom_padding_white">

      <DestinationGallery footerDestinations={footerDestinations} />
      </section>
      {/* <div className="container">
          <div style={{ borderBottom: '0.5px solid #AAAAAA', paddingTop: '30px', paddingBottom: '10px' }}></div>
        </div> */}
      <section className="top_bottom_padding new_ui_bg">
        <ThemesGallery heading="Explore Holidays By Theme" />
      </section>
      <section className="common_padding_testimonial">
        <div className="container">
          {" "}
          <div className="testimonial_flex_sec">
            <div>
              {" "}
              <h4 className="text_left new_ui_heading mb-10">
                Our Customers are Saying...
              </h4>
              <div className="google_rating">
                <div>
                  {" "}
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
                      fill="#FFC107"
                    />
                    <path
                      d="M3.15283 7.3455L6.43833 9.755C7.32733 7.554 9.48033 6 11.9998 6C13.5293 6 14.9208 6.577 15.9803 7.5195L18.8088 4.691C17.0228 3.0265 14.6338 2 11.9998 2C8.15883 2 4.82783 4.1685 3.15283 7.3455Z"
                      fill="#FF3D00"
                    />
                    <path
                      d="M12.0002 22C14.5832 22 16.9302 21.0115 18.7047 19.404L15.6097 16.785C14.5721 17.5745 13.3039 18.0014 12.0002 18C9.39916 18 7.19066 16.3415 6.35866 14.027L3.09766 16.5395C4.75266 19.778 8.11366 22 12.0002 22Z"
                      fill="#4CAF50"
                    />
                    <path
                      d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
                      fill="#1976D2"
                    />
                  </svg>{" "}
                  RATING
                </div>
                <div className="mt-10">
                  <span> 4.7</span>{" "}
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8399"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8399)">
                      <path
                        d="M9.99935 6.58336V11.5L11.9993 13.0417L11.2493 10.5L13.1243 9.16669H10.791L9.99935 6.58336ZM4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>

            <div className="slider_sec">
              <NewTestimonial />{" "}
            </div>
          </div>
        </div>
      </section>

      <NewUIBookWithUs />
      {/* <section className="common_padding new_ui_bg">
        <div className="container">
          {" "}
          <div className="book_ur_holiday">
            {" "}
            <h3 className="new_ui_heading">Book Your Holiday With Mountain Mysteries</h3>
            <h4>
              Lorem ipsum dolor sit amet consectetur. Ipsum elementum placerat
              ultrices tincidunt venenatis.
            </h4>
            <p>
              Lorem ipsum dolor sit amet consectetur. Ipsum elementum placerat
              ultrices tincidunt venenatis.. Est massa id ac orci arcu.. Ut
              ultrices dis blandit in dictum tellus ultricies.. Donec sed
              blandit lorem ut neque.. Porta congue felis convallis ac. Eu
              auctor aliquam volutpat risus. Sit urna sollicitudin augue aliquet
              ultrices.. Sociis nam posuere aliquam tellus ultricies.
              Consectetur sed consequat consectetur venenatis feugiat.. Arcu
              quam nunc tortor adipiscing sit mauris diam id mattis.. Sit vitae
              ac mi eu. At lobortis id cursus ullamcorper aliquam bibendum
              egestas diam mattis.. Purus auctor pulvinar aliquet in turpis
              dictum sit pretium ornare.. Velit fames aenean nunc nibh ut donec
              sed.. Vulputate quam tempus bibendum pretium ornare sed.. Rhoncus
              massa urna pulvinar enim quis vulputate tellus.. Augue ornare
              scelerisque vel netus enim aliquam.. Natoque scelerisque ultrices
              risus urna vitae.. Arcu pharetra ut ut eget cras senectus lorem..
              Morbi parturient donec sit nunc. Erat cursus rutrum quis euismod
              at.. Est mollis tempus aenean ut faucibus.
            </p>
            <h4>
              Lorem ipsum dolor sit amet consectetur. Ipsum elementum placerat
              ultrices.
            </h4>
            <p>
              Lorem ipsum dolor sit amet consectetur. Ipsum elementum placerat
              ultrices tincidunt venenatis.. Est massa id ac orci arcu.. Ut
              ultrices dis blandit in dictum tellus ultricies.. Donec sed
              blandit lorem ut neque.. Porta congue felis convallis ac. Eu
              auctor aliquam volutpat risus. Sit urna sollicitudin augue aliquet
              ultrices.. Sociis nam posuere aliquam tellus ultricies.
              Consectetur sed consequat consectetur venenatis feugiat.
            </p>
            <h4>Lorem ipsum dolor sit amet consectetur.</h4>
            <p>
              Lorem ipsum dolor sit amet consectetur. Ipsum elementum placerat
              ultrices tincidunt venenatis.. Est massa id ac orci arcu.. Ut
              ultrices dis blandit in dictum tellus ultricies.. Donec sed
              blandit lorem ut neque.. Porta congue felis convallis ac. Eu
              auctor aliquam volutpat risus. Sit urna sollicitudin augue aliquet
              ultrices.. Sociis nam posuere aliquam tellus ultricies.
            </p>
          </div>
        </div>
      </section> */}
      <section className="mobile_speak_to_travel_expert new_ui_bg">
        <h4>
          Speak to our <br /> Travel Expert on
        </h4>
        <Link to={"tel:+919816012966"}>+91 98160 12966</Link>
      </section>
      <NewFooterUI footerDestinations={footerDestinations} />

      {/* {loader ? (
        <>
          <div className="container">
            <div className="common_padding">
              <h3>Top Destination</h3>
            </div>
            <div style={{ display: "flex" }} className="images-flex">
              {Array.from({ length: 5 }).map((_, index) => {
                return (
                  <Link
                    style={{ width: "33.33%" }}
                    className="destination_link"
                    key={index}
                  >
                    <div>
                      <Skeleton height={300} />
                    </div>
                    <div style={{ width: "100px" }}>
                      <h6>
                        <Skeleton />
                      </h6>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <>
          <AllDestinationsSlider
            footerDestinations={footerDestinations}
            heading="Top Destinations"
          />
        </>
      )}
      <FilterPackages heading="Top Holiday Packages" />
      )} */}

      {/* <FilterPackages heading="Top Holiday Packages" /> */}

      {/* <Themes />
      <Testimonial />
      <Highlights />
      <Footer footerDestinations={footerDestinations} /> */}
    </div>
  );
}

export default Home;
